import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'; 
import { OrderService } from '../_services/order.service';
import { TokenStorageService } from '../_services/token-storage.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {
  contactUUID: string = "";
  searchInfo: string = "";
  orderInfo: any;
  isSearch: boolean = false;
  p: number = 0;
  limits: number = 10;
  total: number = 0;
  no_results_message: string = "";
  filter = 'all';
  loading_msg = 'Chargement en cours ';
  diplay_loading = this.loading_msg;

  searchOrderForm: FormGroup = new FormGroup({
    search_order: new FormControl("")
  })

  constructor(
    private order: OrderService,
    private tokenStorage: TokenStorageService
  ) { }


    ngOnInit(): void {
      this.contactUUID = this.tokenStorage.getToken() || "";
      this.getOrders();
    }
  
    getOrders(): void {
      this.isSearch = false;
      this.diplay_loading =  this.loading_msg;
      
      this.order.getOrders$(this.contactUUID, this.p).subscribe((data) => {
        this.orderInfo = data.records;
        this.total = data.count;
        this.diplay_loading = '';
        //console.log('total', this.total);
        //console.log( this.orderInfo);
      })
    }

    pageChangeEvent(event: number){
      this.p = event - 1;
  
      if (this.isSearch) {
        this.searchOrder(this.searchInfo);
      }
      else {
        this.getOrders();
      }
    }
  
    onSubmit(values: any): void {
      this.p = 0;
      this.searchInfo = values.search_order;
      this.searchOrder(this.searchInfo);
    }

    changeFilter(btnFilter:string){
      console.log("function called", btnFilter);
      this.filter = btnFilter;
      this.getOrders();
      //window.open('../myURL/mypage.jsp?rurl=' + encodeURIComponent($('display').attr('href')));
    }
  
    searchOrder(search: string): void {
      this.isSearch = true;
      this.diplay_loading =  this.loading_msg;
      
      this.order.searchOrder$(this.contactUUID, search, this.p).subscribe({
        next: (data: any) => {
          this.diplay_loading = '';
          this.orderInfo = data.records;
          this.total = data.count;
          if(this.total == 0){ this.no_results_message = 'Aucun résultat de la recherche: ' + search;}
          console.log("search results: ", data);
        },
        error: (err: any) => {
          console.log("Something went wrong searching orders: ", err.statusText)
        }
      });
    }

    orderPrint(orderId: number): void {
      this.order.exportOrderPrint$(this.contactUUID, orderId).subscribe({
        next: data => {
          console.log("Success printing the order: ", data)
  
          let printContents, popupWin: any;
          printContents = document.getElementById('print-section')!.innerHTML;
          popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
          popupWin.document.open();
          popupWin.document.write(data.order);
          setTimeout(() => {
            popupWin.document.close();
            popupWin.window.print();
          }, 250);
        },
        error: err => {
          console.log('err.',err);
          console.log("Something went wrong while printing the order: ", err.error.errors)
        }
      });
    }

  }


  

